function isIE() {
	var ua = navigator.userAgent;
	/* MSIE used to detect old browsers and Trident used to newer ones*/
	var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

	return is_ie;
}
/*Object-fit: cover - work around for IE*/
if (isIE()) {	
	$('.ieFix').each(function () {
		var $container = $(this), imgUrl = $container.find('img').prop('src');
		if (imgUrl) {
			$container.css('backgroundImage', 'url(' + imgUrl + ') ').addClass('compat-object-fit');
		}
	});
}
